import React, { useState, useEffect, useContext, useRef, useMemo } from "react";
import { TEAM_STREAKS,TEAM_STREAKS_MAPPING } from "../../constants/routes";
import { AuthContext } from "../../store/ContextStore";
import dashboardServices from '../../services/NlpSearchService';
import MultiSelectDropdown from "../MultiSelectDropdown";
import Pill from "../Pill";
import DropdownSelect from "../DropdownSelect";
import Pagination from "../Pagination";
import Spinner from "../Spinner";
import { AgGridReact } from "ag-grid-react";
import { themeQuartz } from "ag-grid-community";
import api from "../../utils/api";
import { PLAYER_PROFILE } from "../../constants/routes";
import { useParams } from "react-router-dom";
import { useReportIssue } from "../../hooks/useReportIssue";
import { ReportIssueModal } from "../ReportIssueModal";
import { useReactiveRef } from '../../utils/UseReactiveState';
import Datepicker from "../Datepicker";
import Table from "../Table";
import Button from "../Button";
import { exportToXLSX } from "../../utils/xlsx";

interface TeamData {
  SportCode: string,
  TeamName: string,
  TeamCode: string,
  stat_mapping: {
    [key: string | number]: any;
  }
}


interface TeamStreaksRes {
  TeamStreaks: {
    [key: string]: any; 
  }[];
  TotalCount: number;
    stat_mapping: { [key: string]: string[] }; 

}

interface TeamStreaksMappingRes {
  [key: string]: string[],
}

const TeamStreaksView = (props: { TeamData: TeamData | null | undefined }) => {

      const [searchString, setSearchString] = useState<string>('');
      const [message, setMessage] = useState<string>('');
      const { selectedSport, user, team, openToast } = useContext(AuthContext);

      const [teamStreaksRes, setTeamStreaksRes] = useState<TeamStreaksRes | null>(null);
      const [teamStreaksMappingRes, setTeamStreaksMappingRes] = useState<TeamStreaksMappingRes | null>(null);
      const [data, setData] = useState<any>(null);

    const [loading, setLoading] = useState<boolean>(false);
    const [filter_config, setfilter_config] = useState<any>(null);
    const [selectedFilters, setSelectedFilters] = useState<any>({});
    const [startDate, setStartDate] = useState<string | null>(null);
    const [endDate, setEndDate] = useState<string | null>(null); 

    const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    
      const [isDisabled, setIsDisabled] = useState(false);
    
      const [streakLength, setStreakLength, streakLengthRef] = useReactiveRef<number>(10);
      const [statValue, setstatValue, statValueRef] = useReactiveRef<number>(10);

      const { sportsCode, teamCode } = useParams();



      const handleDropdownChange = (key: "OPP" | "POS" | "CLASS" | "TEAM" | "RES" | "stat", selectedValue: any) => {
    setSelectedFilters((prev) => {
      const updated = { ...prev };
      let newValue = key === "RES" ? String(selectedValue.code) : selectedValue;

      const currentValues = updated[key] || [];

      if (currentValues.includes(newValue)) {
        updated[key] = currentValues.filter((v: any) => v !== newValue);
      } else {
        updated[key] = [...currentValues, newValue];
      }

      console.log("Updated Filters:", updated);
      return updated;
    });
  };


    const handleStartDateChange = (newDate: string) => {
    setStartDate(newDate);

    if (endDate && new Date(newDate) > new Date(endDate)) {
      setEndDate(null);
    }
  };

  const handleEndDateChange = (newDate: string) => {
    setEndDate(newDate);
  };

   const handleClearFilters = () => {
    setSelectedFilters({});
    setstatValue(10);
    setStreakLength(10);
    setStartDate(null);
    setEndDate(null);
    setTeamStreaksRes(null);
    setCurrentPage(0);
  };

  const handleDeleteFilter = (filter: string) => {
    if (filter.startsWith("Start Date:")) {
      setStartDate(null);
      setTeamStreaksRes(null);
      return;
    }

    if (filter.startsWith("End Date:")) {
      setEndDate(null);
      setTeamStreaksRes(null);
      return;
    }

    const isStatCategory = selectedFilters?.stat?.includes(filter);
    
    if (isStatCategory) {
      const categoryStats = teamStreaksMappingRes?.[filter] || [];
      const updatedStat = selectedFilters.stat.filter((s: string) => s !== filter);
      
      let updatedSubstat = selectedFilters.substat;
      if (selectedFilters.substat && categoryStats.includes(selectedFilters.substat)) {
        updatedSubstat = null;
      }
      
      setSelectedFilters({
        ...selectedFilters,
        stat: updatedStat,
        substat: updatedSubstat
      });
      setTeamStreaksRes(null);
      return;
    }

    if (selectedFilters?.substat === filter) {
      setSelectedFilters({ ...selectedFilters, substat: null });
      setTeamStreaksRes(null);
      return;
    }
  };

    const formatColumnName = (key: string): string => {
    return key
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };
  
  const getColDefs = () => {
    if (!teamStreaksRes?.TeamStreaks?.length) return [];

    const keys = Object.keys(teamStreaksRes.TeamStreaks[0]);

    return keys.map((key) => {
      const isDate = key.toLowerCase().includes("date");
      const formattedName = formatColumnName(key);

      const colDef: any = {
        field: key,
        headerName: formattedName,
        sortable: true,
      };

      if (isDate) {
        colDef.filter = "agDateColumnFilter";
        
        // FIXED: Robust comparator that handles nulls, undefined, "-", and invalid dates
        colDef.comparator = (valueA: any, valueB: any) => {
            const toTimestamp = (dateStr: any): number | null => {
                if (!dateStr || dateStr === "-") return null;
                const str = String(dateStr).trim();

                let date;
                // Handle DD/MM/YYYY format explicitly if present
                if (str.match(/^\d{1,2}\/\d{1,2}\/\d{4}$/)) {
                    const [day, month, year] = str.split('/').map(Number);
                    date = new Date(year, month - 1, day);
                } else {
                    // Handle ISO YYYY-MM-DD or other standard formats
                    date = new Date(str);
                }

                return isNaN(date.getTime()) ? null : date.getTime();
            };

            const timeA = toTimestamp(valueA);
            const timeB = toTimestamp(valueB);

            if (timeA === timeB) return 0; // handles both being null
            if (timeA === null) return 1; // sort nulls to the end (bottom)
            if (timeB === null) return -1;

            return timeA - timeB;
        };

        colDef.filterParams = {
          debounceMs: 500,
          suppressAndOrCondition: true,
          comparator: (filterLocalDateAtMidnight: Date, cellValue: string) => {
            if (cellValue == null) {
              return 0;
            }
            const cellDate = new Date(cellValue + "T00:00:00");
            if (isNaN(cellDate.getTime())) {
              return 0;
            }
            if (cellDate < filterLocalDateAtMidnight) {
              return -1;
            } else if (cellDate > filterLocalDateAtMidnight) {
              return 1;
            } else {
              return 0;
            }
          },
        };
        colDef.valueFormatter = (params: any) => {
          if (params.value) {
            const date = new Date(params.value + "T00:00:00");
            return isNaN(date.getTime()) ? "-" : date.toLocaleDateString();
          }
          return "-";
        };
      } else {
        colDef.filter = true;
        colDef.valueFormatter = (params: any) => params.value ?? "-";
      }

      return colDef;
    });
  };

    const getTeamStreaksMapping = async () => {
    try {
      setLoading(true);
      const res: { data: TeamStreaksMappingRes } = await api.get(
        TEAM_STREAKS_MAPPING,
        {
          params: {
            SportCode: props.TeamData?.SportCode || sportsCode  , 
          },
        }
      );

      console.log("Mapping Response:", res);
      setTeamStreaksMappingRes(res.data);
    } catch (err) {
      console.error(err);
      openToast("Failed to load streak categories", "red");
    } finally {
      setLoading(false);
    }
  };

const getTeamStreaks = async () => {
  if (!teamCode || !(sportsCode || props.TeamData?.SportCode)) {
    console.warn("Missing SportCode or TeamCode", {
      SportCode: sportsCode || props.TeamData?.SportCode,
      TeamCode: teamCode,
    });
    return;
  }

  try {
    setLoading(true);
    setCurrentPage(0);

    const payload = {
      SportCode: sportsCode || props.TeamData?.SportCode,
      TeamCode: teamCode,
      stat: selectedFilters.substat,
      stat_value: statValueRef.current,
      streak_length: streakLengthRef.current,
      start_date: startDate,
      end_date: endDate,
    };

    console.log("FINAL PAYLOAD:", payload);

    const res = await api.post(TEAM_STREAKS, payload);
    setTeamStreaksRes(res.data);
  } catch (err) {
    openToast("Failed to load team streaks", "red");
    setTeamStreaksRes({ TeamStreaks: [], TotalCount: 0 });
  } finally {
    setLoading(false);
  }
};


  const handleExport = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (!teamStreaksRes || teamStreaksRes.TeamStreaks.length === 0) {
      openToast("No data to export", "red");
      return;
    }

    try {
      exportToXLSX(
        teamStreaksRes.TeamStreaks,
        `Team_Streaks_${props.TeamData?.TeamName || 'data'}.xlsx`
      );
      openToast("Data exported successfully", "green");
    } catch (error) {
      console.error("Export error:", error);
      openToast("Failed to export data", "red");
    }
  };


  const handleApplyFilters = () => {
    let missing: string[] = [];

    if (!selectedFilters.substat) missing.push("Stat");
    if (statValueRef.current <= 0) missing.push("Stat Value (must be greater than 0)");
    if (streakLengthRef.current <= 0) missing.push("Streak Length (must be greater than 0)");

    if (missing.length > 0) {
      alert(`Please select/correct the following:\n\n${missing.join("\n")}`);
      return;
    }

    getTeamStreaks();
  };

    const handleStatValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value;
      if (value === '') {
        setstatValue(0);
      } else {
        const numValue = parseInt(value, 10);
        if (!isNaN(numValue) && numValue >= 0) {
          setstatValue(numValue);
        }
      }
    };
  
    const handleStreakLengthChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value;
      if (value === '') {
        setStreakLength(0);
      } else {
        const numValue = parseInt(value, 10);
        if (!isNaN(numValue) && numValue >= 0) {
          setStreakLength(numValue);
        }
      }
    };

   
      useEffect(() => {
        setfilter_config({
          PageNumber: 1,
          PageSize: 1,
          entity: "Team",
        });
   
        setData({ teams: ["abc"] });
        getTeamStreaksMapping();
      }, []); 

    return ( 
    <div className="w-full flex flex-col gap-4">
      {/* FILTER DISPLAY */}
      <div className="flex flex-row gap-2 items-center justify-between flex-wrap">
        {([selectedFilters?.substat, ...(selectedFilters?.stat ?? []), startDate, endDate].filter(Boolean)?.length > 0) && (
          <p className="font-primary font-semibold text-lg">
            <div className="flex flex-row items-center gap-2 w-full">
              <div className="text-sm font-medium">Filters:-</div>
              <div className="flex gap-2 flex-wrap max-w-[40rem] px-2">
                {[
                  selectedFilters?.substat,
                  ...(selectedFilters?.stat ?? []),
                  startDate ? `Start Date: ${startDate}` : null,
                  endDate ? `End Date: ${endDate}` : null,
                ]
                  .filter(Boolean)
                  .map((filter, idx) => (
                    <Pill key={idx} text={String(filter)} showCross onClick={() => handleDeleteFilter(String(filter))} />
                  ))}
              </div>
            </div>
          </p>
        )}

        {/* EXPORT BUTTON */}
        <div className="flex flex-row gap-2 items-center justify-end flex-wrap">
          <Button
            handleButtonClick={handleExport}
            color={team.colorCode}
            isDisabled={!teamStreaksRes || teamStreaksRes?.TeamStreaks.length === 0}
            text="Export"
            icon="/export_icon.png"
            type=""
            iconAllignment="left"
            size=""
          />
        </div>
      </div>

      <hr className="h-px my-0.5 bg-[#AEAEAE] border-0" />

      {/* MAIN LAYOUT */}
      <div className="flex flex-row gap-5 mb-2">
        {/* FILTER PANEL */}
        {data?.teams?.length > 0 && (
          <div className="max-w-[270px] w-full bg-white rounded-[10px] border border-[#DEE7F4] p-4 mt-1.5 flex flex-col gap-2">
            <div className="flex flex-row justify-between">
              <p className="text-md font-semibold font-primary">Filters</p>
              <p
                className="text-sm font-semibold font-primary cursor-pointer"
                style={{ color: team.colorCode }}
                onClick={handleClearFilters}
              >
                Clear All
              </p>
            </div>

            <hr className="h-px my-0.5 bg-[#E5E5E5]" />

            {/* CATEGORY */}
            <p className="text-sm font-secondary font-semibold text-[#5B5B5B]">Category</p>
            <MultiSelectDropdown
              options={Object.keys(teamStreaksMappingRes ?? {})}
              options2={[]}
              def="Select Category"
              setSelectedOption={handleDropdownChange}
              selectedOption={selectedFilters}
              filterKey="stat"
            />

            {/* STAT */}
            <p className="text-sm font-secondary font-semibold text-[#5B5B5B]">Stat</p>
            <DropdownSelect
              options={selectedFilters?.stat?.map((s: string) => teamStreaksMappingRes?.[s]).flat() ?? []}
              options2={[]}
              def="Select Stat"
              setSelectedOption={(option) => setSelectedFilters({ ...selectedFilters, substat: option })}
              selectedOption={selectedFilters.substat}
            />

            {/* STAT VALUE */}
            <div>
              <div className="text-sm font-secondary font-semibold text-[#5B5B5B] pb-2">Stat Value</div>
              <input
                type="number"
                className="w-full border rounded-lg px-5 py-2.5"
                value={statValue === 0 ? '' : statValue}
                placeholder="Enter Stat (default: 10)"
                onChange={handleStatValueChange}
                min="1"
              />
            </div>

            {/* STREAK LENGTH */}
            <div>
              <div className="text-sm font-secondary font-semibold text-[#5B5B5B] pb-2">Streak Length</div>
              <input
                type="number"
                className="w-full border rounded-lg px-5 py-2.5"
                value={streakLength === 0 ? '' : streakLength}
                placeholder="Enter Streak Length (default: 10)"
                onChange={handleStreakLengthChange}
                min="1"
              />
            </div>

            {/* DATE RANGE */}
            <p className="text-sm font-secondary font-semibold text-[#5B5B5B]">Date Range</p>
            <div className="flex gap-2">
              <Datepicker
                date={startDate || ""}
                setDate={handleStartDateChange}
                disabled={false}
                type="DATE_MIN"
                className="w-[114px]"
              />

              <Datepicker
                date={endDate || ""}
                setDate={handleEndDateChange}
                disabled={!startDate}
                type="DATE_MAX"
                className="w-[114px]"
                startDate={startDate || undefined}
              />
            </div>

            {/* APPLY BUTTON */}
            <button
              className="py-3 bg-[#A8042D] text-white rounded-lg text-sm font-medium hover:bg-[#8a0325] transition-colors"
              onClick={handleApplyFilters}
            >
              View Results
            </button>
          </div>
        )}

        {/* TABLE - NOW WITH CLIENT-SIDE SORTING ON ALL DATA */}
        <div className="flex-grow">
          <AgGridReact
            rowData={teamStreaksRes?.TeamStreaks || []}
            columnDefs={getColDefs()}
            theme={themeQuartz}
            loadingOverlayComponent={Spinner}
            loading={loading}
            defaultColDef={{
              flex: 1,
              sortable: true,
              filter: true,
              valueFormatter: (params) => params.value ?? "-",
              // This is the fallback comparator for non-date columns
              comparator: (valueA, valueB) => {
                const isADash = valueA === "-" || valueA === null || valueA === undefined;
                const isBDash = valueB === "-" || valueB === null || valueB === undefined;
                
                if (isADash && isBDash) return 0;
                if (isADash) return 1;
                if (isBDash) return -1;
                
                const isNumericString = (val: any) => /^-?\d*\.?\d+$/.test(String(val));

                if (isNumericString(valueA) && isNumericString(valueB)) {
                  return parseFloat(String(valueA)) - parseFloat(String(valueB));
                }
                
                return String(valueA).localeCompare(String(valueB));
              },
            }}
            pagination={true}
            paginationPageSize={itemsPerPage}
            paginationPageSizeSelector={[10, 25, 50, 100]}
            onPaginationChanged={(params) => {
              const newPageSize = params.api.paginationGetPageSize();
              if (newPageSize !== itemsPerPage) {
                setItemsPerPage(newPageSize);
              }
            }}
          />

        </div>
      </div>
    </div>
    
    );
}
export default TeamStreaksView;